import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import { toast } from "react-toastify";
import generalFunc from "../Utils/generalFunc";
import {
  noNetworkMsg,
  exErrMsg,
  successMsg,
  errorMsg,
  clearMsg,
  infoMsg,
} from "../Utils/apiToasts";
import { offline } from "../Constants/api";
import { controller } from "../Constants/api";


const skillsBaseController = "api/skillCenters";


// Get all Centres
export const getAllCentres = async params => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${skillsBaseController}/get-all-skill-centers`,{params});

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          // toastr.success('Fetched all centres successfully')

          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
    }
  }
}


// Create Skill Centre
export const createSkillCentre = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.post(`${skillsBaseController}/create-skilcenter`, body);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          toastr.success('Created skill acquisition centre successfully')
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
    }
  }
}


// Activate Centre
export const activateSkillCentre = async id => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.patch(`${skillsBaseController}/activateskillcenter/${id}`);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          toastr.success('Activated skill acquisition centre successfully')
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
    }
  }
}

// deactivate Centre
export const deactivateSkillCentre = async id => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.patch(`${skillsBaseController}/deactivateskillcenter/${id}`);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          toastr.success('Deactivated skills acquisition centre successfully')
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
    }
  }
}

// edit Centre
export const editSkillCentre = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.put(`${skillsBaseController}/update-skill-center`, body);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          toastr.success('Skills acquisition centre edit successfull')
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
      console.log(err)
      return err
    }
  }
}


// Get Total-level details for acquisition centres
export const getTotalSkillCentersDetails = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${skillsBaseController}/get-total-skill-centers-details`, body);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          // toastr.success('Skills acquisition centre total detail fetched successfully')
          return response.data.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
      console.log(err)
      return err
    }
  }
}

//===============Api for Export Acquisition Centre as CSV ========================
export const ExportSkillAcquisition = async () => {
  if (offline) {
    noNetworkMsg();
  } else {
    toastr.info("Downloading...", "Pending");
    await api
      .get(`${skillsBaseController}/export-skill-centers`, { responseType: "blob" })
      .then((response) => {
        infoMsg("Downloading...");
        if (typeof response !== "undefined") {
          if (response.status === 200 || response.status === 204) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `SAED Skill Acquisition Centre ${generalFunc.getCurrentYear()}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            clearMsg();
            successMsg("Download Skill Acquisition Centre SpreadSheet", "Success");
          } else {
            clearMsg();
            errorMsg("Download Skill Acquisition Centre SpreadSheet", "Error in fetching API");
          }
        }
      })
      .catch((err) => {
        clearMsg();
        exErrMsg(err.response.data.message,"");
      });
  }
};


// Print Skill Acquisition Centres
export const PrintSkillAcquisition = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    toastr.info("Printing...", "Pending");
    try {
      const response = await api.get(`${skillsBaseController}/print-skill-centers`, { responseType: "blob" });

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          const url = URL.createObjectURL(new Blob([response.data], {type:"application/pdf"}));
          var preview = window.open(url);
          preview.print();
          toastr.clean();
          toastr.success("Print Skills Acquisition", "Success");
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toast.clean()
      toastr.error(err.response.data.message)
      console.log(err)
      return err
    }
  }
}

// Get all Centres without pagination
export const getAllCentersSelect = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${skillsBaseController}/get-all-skill-centers-no-pagination`);

      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          toastr.success('Fetched all centers successfully')

          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.message)
    }
  }
}





